import React from 'react';
import { C, DISP, BODY, FadeUp, Kicker, SectionH2, SectionSub, SECTION_PAD, useSectionView } from './shared';

const LOOP = [
  'Open ScalitOS',
  "See today's priority",
  'Create the work',
  'Publish or schedule',
  'Track progress',
  'Return to a smarter plan',
];

export const HabitLoopSection = () => {
  const ref = useSectionView('habit_loop');
  return (
    <section ref={ref} style={{ padding: SECTION_PAD }}>
      <div style={{ maxWidth: 1000, margin: '0 auto', textAlign: 'center' }}>
        <FadeUp><Kicker center>The daily rhythm</Kicker></FadeUp>
        <FadeUp delay={80}>
          <SectionH2 center>Built for a 20-minute<br />marketing habit.</SectionH2>
        </FadeUp>
        <FadeUp delay={140}>
          <SectionSub center>
            No streaks, no guilt, no noise. Just a short loop that keeps your marketing moving even on your busiest weeks.
          </SectionSub>
        </FadeUp>

        <FadeUp delay={200}>
          <div style={{ marginTop: 48, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 10 }}>
            {LOOP.map((step, i) => (
              <React.Fragment key={i}>
                <span style={{
                  padding: '12px 18px', borderRadius: 999,
                  border: i === 1 ? `1px solid ${C.borderLime}` : `1px solid ${C.border}`,
                  background: i === 1 ? 'rgba(200,241,53,0.07)' : C.surface,
                  fontFamily: BODY, fontSize: 14, fontWeight: 600,
                  color: i === 1 ? C.lime : C.text,
                }}>
                  {step}
                </span>
                {i < LOOP.length - 1 && <span aria-hidden="true" style={{ color: C.muted, fontSize: 15 }}>→</span>}
              </React.Fragment>
            ))}
            <span aria-hidden="true" style={{ color: C.lime, fontSize: 15 }}>↻</span>
          </div>
        </FadeUp>

        <FadeUp delay={280}>
          <p style={{ marginTop: 32, fontFamily: DISP, fontWeight: 700, fontSize: 18, color: 'rgba(242,245,234,0.6)' }}>
            The more you use it, the better it knows your business.
          </p>
        </FadeUp>
      </div>
    </section>
  );
};
